
import { Component, Prop } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
    components: {
    }
})
export default class PuzzleImage extends Vue {
    hasBevelBorder!: boolean
    
    @Prop()
    imageName;

    @Prop()
    catagory;

    @Prop()
    height;

    @Prop()
    width;

    @Prop()
    pixelRatio;

    created() {
        this.hasBevelBorder = this.$store.getters.isMatWithCore
    }


    get imagePath() {
        try {
            require(`./images/${this.catagory}/${this.imageName}`)
        }
        catch (e) {
            if (!this.imageName.includes("thumb")) {
                alert("missing puzzle image: " + this.imageName)
            }
        }
        let path = "img/" + this.imageName
        //console.log("imagePath: " + path)

        return path
    }

    get puzzleStyle() {

        let heightPx = this.height * this.pixelRatio + 'px'
        let widthPx = this.width * this.pixelRatio + 'px'
        let sty = "height: " + heightPx + "; width: " + widthPx + ";";
        if (this.hasBevelBorder) {
            sty = sty + "border: 3px solid white;"
        }
        //console.log("puzzle image style: " + sty)
        return sty
    }

}
